import Vue from 'vue';
import Router from 'vue-router';

import VueResource from 'vue-resource';
import vueMoment from 'vue-moment';

import ArenaAdminMainPage from '@/components/ArenaGlobalAdmin/MainPage/MainPage.vue';
import Precompilation from '@/components/Precompilation/Precompilation.vue';
import ClearCachePage from '@/components/ClearCachePage/ClearCachePage.vue';
import GamesVersionsMainPage from '@/components/GamesVersionsControl/GamesVersionsMainPage/GamesVersionsMainPage.vue';
import ArenasControlMain from '@/components/ArenasControl/ArenasControlMain/ArenasControlMain.vue';
import HomePage from '@/components/HomePage/HomePage.vue';
import UsersControlMain from '@/components/UsersControl/UsersControlMain/UsersControlMain.vue';
import FeedsControl from '@/components/FeedsControl/FeedsControlMain/FeedsControlMain.vue';
import FeedsDetails from '@/components/FeedsDetails/FeedsDetailsMain/FeedsDetailsMain.vue';
import GamesSorting from '@/components/GamesSortingControl/GamesSortingMain/GamesSortingMain.vue';
import ChangeLog from '@/components/ChangeLog/ChangeLog.vue';
import GameDataChangeLog from '@/components/GameDataChangeLog/GameDataChangeLog.vue';
import CheaterSearch from '@/components/CheaterSearch/CheaterSearch.vue';
import PartnersPage from '@/components/Partners/MainPage/PartnersPage.vue';
import GlobalRedirectsPage from '../components/GlobalRedirects/GlobalRedirectsPage.vue';
import SyndicationConfigPage from '../components/SyndicationConfig/SyndicationConfigPage.vue';
import SyndicationPartnerCustomUiPage from '../components/SyndicationConfig/SyndicationPartnerCustomUiPage.vue';
import ArenaStatusManagementPage from '../components/ArenaStatusManagmentPage/ArenaStatusManagementPage.vue';
import PushNotifications from '../components/PushNotifications/PushNotifications.vue';
import GameRendering from '../components/GameRendering/GameRendering.vue';
import IframeGamesList from '../components/IframeGamesList/IframeGamesList.vue';
import SamplingConfiguration from '../components/SamplingConfiguration/SamplingConfiguration.vue';
import BlueBannerManagement from '../components/BlueBannerManagement/BlueBannerManagement.vue';
import EventCategoryConfig from '../components/EventCategory/EventCategoryConfig.vue';
// #region Arkadium.com specific section
import CategoriesSEO from '../components/Arkadium.com_Specific/CategoiriesSeo/CategoriesSEO.vue';
import ArkCarousel from '../components/Arkadium.com_Specific/ArkCarousel/ArkCarousel.vue';

import Feeds from '../pages/feeds/';
import Games from '../pages/games/';
import GameMetas from '../pages/games/metas/';
import GameFeeds from '../pages/games/feeds/';
import GameRollouts from '../pages/games/rollouts/';
import GameOrdering from '../pages/games/game-ordering.vue';
import FeedOrdering from '../pages/feeds/feed-game-ordering.vue';
import MetadataManagement from '../pages/metadata-management/index.vue';
import MetadataManagementEdit from '../pages/metadata-management/edit.vue';
import MetadataManagementNew from '../pages/metadata-management/new.vue';

import Developers from '../pages/developers/';
import AnalyticsConfigs from '../pages/analytics-configs/';
// #endregion

Vue.use(Router);
Vue.use(VueResource);
Vue.use(vueMoment);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: HomePage,
        },
        { path: '/games', component: Games.List },
        { path: '/games/new', component: Games.New },
        { path: '/games/:id', component: Games.Edit },
        { path: '/games/:gameId/metas', component: GameMetas.List },
        { path: '/games/:gameId/metas/new', component: GameMetas.New },
        { path: '/games/:gameId/metas/:id', component: GameMetas.Edit },
        { path: '/games/:gameId/feeds', component: GameFeeds.List },
        { path: '/games/:gameId/feeds/new', component: GameFeeds.New },
        { path: '/games/:gameId/feeds/:id', component: GameFeeds.Edit },
        { path: '/game-rollouts', component: GameRollouts.List },
        { path: '/game-rollouts/new', component: GameRollouts.New },
        { path: '/game-rollouts/:id', component: GameRollouts.Edit },
        { path: '/metadata-management', component: MetadataManagement },
        { path: '/metadata-management/new', component: MetadataManagementNew },
        { path: '/metadata-management/:id', component: MetadataManagementEdit },
        { 
          path: '/global-games-ordering', 
          name: 'game-ordering',
          component: GameOrdering,
          props: true
        },
        { 
          path: '/feed-ordering', 
          name: 'feed-ordering',
          component: FeedOrdering,
          props: true
        },
        { path: '/feeds', component: Feeds.List },
        { path: '/feeds/:id', component: Feeds.Edit },
        { path: '/feeds/:id/games/:gameId', component: Feeds.Games.Edit },
        { path: '/developers', component: Developers.List },
        { path: '/developers/:id', component: Developers.Edit },
        { path: '/analytics-configs', component: AnalyticsConfigs.List },
        { path: '/analytics-configs/new', component: AnalyticsConfigs.Edit },
        { path: '/analytics-configs/:id', component: AnalyticsConfigs.Edit },
        {
            path: '/arena-global-admin',
            component: ArenaAdminMainPage,
        },
        {
            path: '/arena-status-management',
            component: ArenaStatusManagementPage,
        },
        {
            path: '/push-notifications',
            component: PushNotifications,
        },
        {
            path: '/ark-categories-seo',
            component: CategoriesSEO,
        },
        {
            path: '/ark-carousel',
            component: ArkCarousel,
        },
        {
            path: '/global-redirects',
            component: GlobalRedirectsPage,
        },
        {
            path: '/syndication-config',
            component: SyndicationConfigPage,
        },
        {
            path: '/syndication-config/partner/:partnerIndex/custom-ui',
            name: 'syndication-partner-custom-ui',
            component: SyndicationPartnerCustomUiPage,
            props: (route) => {
                const n = parseInt(route.params.partnerIndex, 10);
                return { partnerIndex: Number.isNaN(n) || n < 0 ? -1 : n };
            },
        },
        {
            path: '/arenas-control',
            component: ArenasControlMain,
        },
        {
            path: '/partners',
            component: PartnersPage,
        },
        {
            path: '/games-versions-control',
            component: GamesVersionsMainPage,
        },
        {
            path: '/users-control',
            component: UsersControlMain,
        },
        {
            path: '/feeds-control',
            component: FeedsControl,
        },
        {
            path: '/feeds-details',
            component: FeedsDetails,
        },
        {
            path: '/sorting-control',
            component: GamesSorting,
        },
        {
            path: '/pre-compilation',
            component: Precompilation,
        },
        {
            path: '/clear-cache',
            component: ClearCachePage,
        },
        {
            path: '/change-log',
            component: ChangeLog,
        },
        {
            path: '/game-data-change-log',
            component: GameDataChangeLog,
        },
        {
            path: '/cheaters',
            component: CheaterSearch,
        },

        {
            path: '/game-rendering',
            component: GameRendering,
        },
        {
            path: '/iframe-games-list',
            component: IframeGamesList,
        },
        {
            path: '/sampling-configuration',
            component: SamplingConfiguration,
        },
        {
            path: '/message-banner-management',
            component: BlueBannerManagement,
        },
        {
            path: '/custom-categories',
            component: EventCategoryConfig,
        },
        {
            path: '/custom-categories/global-settings',
            redirect: { path: '/custom-categories', query: { globalSettings: '1' } },
        },
        
        { path: '*', redirect: '/' },
    ],
});
